// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '13px',
    whiteSpace: 'nowrap',
  },
  select: {
    fontSize: '13px',
  },
  menuItem: {
    fontSize: '13px',
  },
});

export default styles;
